import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslatesProcertService } from '../translates/translates-procert.service';

@Injectable({ providedIn: 'root' })

export class SnackBarService 
{
  duration_miliseconds = 4000;
  constructor(private snackBar: MatSnackBar, private translate: TranslatesProcertService) { }

  success(key_message: string) 
  {
    this.snackBar.open(this.translate.translateInstant(key_message), this.translate.translateInstant('Common.Close'), 
    {
      duration: this.duration_miliseconds,
      horizontalPosition: 'right',
      verticalPosition: 'bottom',
      panelClass: 'notificationSuccess',
    });
  }

  error(key_message: string) 
  {
    this.snackBar.open(this.translate.translateInstant(key_message), this.translate.translateInstant('Common.Close'), 
    {
      duration: this.duration_miliseconds,
      horizontalPosition: 'right',
      verticalPosition: 'bottom',
      panelClass: 'notificationError',
    });
  }

}
